import { useQuery } from "@tanstack/react-query";

import createPrivateAdminPanelInstance from "../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../api/ApiRoutes";

const fetchAdmins = async () => {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken
  );

  const response = await PrivateAdminPanelInstance.get(API_ROUTES.GET_ADMINS);

  return response?.data?.data ?? [];
};

export const useGetAdmins = () => {
  return useQuery({
    queryKey: ["GET_ADMINS"],
    queryFn: fetchAdmins,
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  });
};
